import asset from '@/api/itinerary-template'

export default {
  getNewTemplate ({ commit }, payload) {
    return asset.getNewTemplate(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.status === true) {
          return response.data
        }
      })
  },
  addNewTemplate ({ commit }, payload) {
    return asset.addNewTemplate(payload)
      .then(response => {
        if (response && response.status === 200) {
          return response
        }
      })
  }
}
